import { Box, ButtonGroup, IconButton, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

// import Echeck from "./views/Echeck";
import { useGridApiRef } from "@mui/x-data-grid";
import RelationOrders from "./views/Orders";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { warehouseRelationDataConfig } from "./warehouseRelationDataConfig";
import RelationInbounds from "./views/Inbounds";
import RelationReturns from "./views/Returns";
import RelationProducts from "./views/Products";
import RelationVirtualProducts from "./views/VirtualProducts";
import RelationInvoices from "./views/Invoices";
import RelationRunners from "./views/Runners";
import RelationShelfwarmers from "./views/Shelfwarmers";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OverflowRow from "../../../../components/theme/OverflowRow";
import { Edit, ArrowRightAlt, Business, FullscreenExitSharp } from "@mui/icons-material";
import ShValidatedInputDropdown from "../../../../components/theme/dropdowns/ShValidatedInputDropdown";
import { useGetRelationQuery, useGetRelationsSelectQuery, useSyncWebshopMutation } from "../../../../newapi/global/relation/relationSlice";
import { useGetWebshopCountQuery } from "../../../../newapi/webshop/webshopSlice";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import SpRelationDetails from "../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails";
import ContactsIcon from '@mui/icons-material/ContactsOutlined';
import useTabViewUrl from "../../../../hooks/useTabViewUrl";
import AMRelationdata from "../../../../components/global/Modals/ActionModal/AMRelationdata";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../../utils/toasts";
import Financial from "./views/Financial";
import RelationOrderLogs from "./views/RelationOrderLogs";
import Saleschannels from "./views/Saleschannels";
import RelationUsers from "./views/RelationUsers";
import { useFindInvoiceCategoryForRelationQuery } from "../../../../newapi/financial/invoiceCategorySlice";
import Text from "../../../../components/theme/text/Text";
import InvoiceTotalsPanel from "../../../../components/global/dashboard/InvoiceTotalsPanel";
import OrderTotalsPanel from "../../../../components/global/dashboard/OrderTotalsPanel";

const RelationData = () => {
  const { t, ready } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isExtended,setIsExtended] = useState(false);
  const [spLoading, setSpLoading] = useState();
  //const relationApiRef = useGridApiRef();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [relation, setRelation] = useState(queryParams.get("relation")); // "MA
  // const { data: relationData, isLoading: relationIsLoading } = useGetRelationQuery(relation);
  const [config, setConfig] = useState(warehouseRelationDataConfig());

  // The totals panels sit above the tab view and belong to one tab each, so the open tab reports
  // itself up. A tab that closes only clears the panel if it is still the one showing, which
  // keeps the tab being left from wiping out the one being opened.
  const [activePanel, setActivePanel] = useState(null);
  const reportPanel = (key) => (active) =>
    setActivePanel((prev) => (active ? key : prev === key ? null : prev));
  const {data: relations} = useGetRelationsSelectQuery();
  
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const filterPopoverOpen = Boolean(filterAnchorEl);
  const filterPopoverId = filterPopoverOpen ? 'simple-popover' : undefined;

  const { data: relationInvoiceData, isLoading,isFetching,isError } = useFindInvoiceCategoryForRelationQuery(relation,
  {
      skip: !relation
  });

  // The saleschannels tab shows how many channels of this relation are live.
  const { data: webshopCounts } = useGetWebshopCountQuery({relationId: relation},
  {
      skip: !relation
  });

  useEffect(() => {
    setConfig(warehouseRelationDataConfig(undefined, {saleschannels: webshopCounts?.active}));
  }, [webshopCounts]);

  // console.log(relation);
  const [syncWebshop] = useSyncWebshopMutation();
  // Enable URL-based view navigation (enabled by default)
  const tabViewUrl = useTabViewUrl();
  
  // Sync relation state with URL params when location changes
  useEffect(() => {
    const urlRelation = queryParams.get("relation");
    if (urlRelation !== relation) {
      setRelation(urlRelation);
    }
  }, [location.search]);
  
  const getRelationDetails = () => {
    if(!spLoading) {
        setSpLoading(true);
    }
    setIsExtended(true);
};

const handleInput = (key, val) => {
    setRelation(val);
    // Update URL parameters to maintain state
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('relation', val);
    navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
};
  
  return (
    <Box sx={{ background: "", width: 1, paddingTop: 3 }}>
      {ready ? (
        <>
          <OverflowRow>
            <Box
              sx={{
                // background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                flex: 1,
                // boxShadow: '0px 1px 2px 1px rgba(49, 65, 95, 0.15)',
                position: "relative", //Needed for absolutely positioned things
                display: "flex",
                justifyContent: "space-between",
                // width:1,
                borderRadius: 4,
                gap: 1,
                pt:4,
                // "@media screen and (max-width: 47.9375em)" : {
                //     width: "unset"
                // }
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "start", width: 1,}}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                  <ContactsIcon 
                    sx={{ 
                      fontSize: '2rem',
                      color: theme.palette.mode === "dark" ? colors.primary[400] : colors.primary[600],
                      marginRight: 1
                    }} 
                  />
                  <ShValidatedInputDropdown
                    displayName={"name"} 
                    changeField={"id"}
                    valueKey={"id"}
                    closeOnSelection
                    searchOptions={{
                      enabled: true,
                      placeholder: t("search_relation_placeholder")
                    }}
                    styles={{
                      // minWidth: 300,
                      // "& .MuiInputBase-root": {
                      //   fontSize: "2.5rem",
                      //   fontWeight: 700,
                      //   color: "inherit",
                      //   "& .MuiSelect-select": {
                      //     fontSize: "2.5rem",
                      //     fontWeight: 700,
                      //     padding: "12px 32px 12px 16px"
                      //   }
                      // }
                    }}
                    disallowDeselection
                    name="relationId"
                    selected={relation ? parseInt(relation) : -1}
                    options={relations ? relations : []}
                    noSelection={t("choose_other_relation")} 
                    onChange={handleInput}
                    idSX={{
                      background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[200],
                    }}
                  />
                  {(relationInvoiceData && relationInvoiceData.name) && (
                    <Box
                      sx={{
                        height:32,
                        background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                        border: `1px solid ${theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                        borderRadius:4,
                        px:2,
                        lineHeight:'32px',
                        whiteSpace:'nowrap'
                      }}
                    >
                      <Text variant={theme.palette.mode === "dark" ? "blue" : "primary"} bold>{relationInvoiceData.name}</Text>
                    </Box>
                  )}
                </Box>
              </Box>
              <Box sx={{ display:"flex",gap:1.5, }}>
                {/* <ButtonGroup version={2}> */}
                  <Shbutton
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    onClick={getRelationDetails}
                    endIcon={<Edit />}
                    variant="contained"
                    sx={{
                      px:2,
                    }}
                  >
                    {t("details")}
                  </Shbutton>
                  <Shbutton
                      onClick={(event) => {setFilterAnchorEl(event.currentTarget);}}
                      className={"group-btn"}
                      // onClick={props.action}
                      color={"primaryGrey"}
                      variant="contained"
                  >
                      {t('actions')}
                  </Shbutton>
                {/* </ButtonGroup> */}

                <AMRelationdata 
                  id={filterPopoverId}
                  open={filterPopoverOpen}
                  onClose={() => {setFilterAnchorEl(null)}}
                  anchorEl={filterAnchorEl}
                  syncProducts={async () => {
                    await syncWebshop({
                      id:relation,
                      type:'products'
                    })
                    .unwrap()
                    .then(res => {
                      showToastMessagePostRequest(t,res);
                    })
                    .catch(err => {
                      showToastMessageRequestError(t("sync_failed"), t, err);
                    })
                  }}
                  syncStock={async () => {
                    await syncWebshop({
                      id:relation,
                      type:'stock'
                    })
                    .unwrap()
                    .then(res => {
                      showToastMessagePostRequest(t,res);
                    })
                    .catch(err => {
                      showToastMessageRequestError(t("sync_failed"), t, err);
                    })
                  }}
                />
              </Box>
            </Box>
          </OverflowRow>

          {activePanel === "orders" && <OrderTotalsPanel relationId={relation} />}
          {activePanel === "invoices" && <InvoiceTotalsPanel relationId={relation} />}

          <TabView3
            tabConfig={config}
            // enableUrlViews is true by default, no need to specify
            // ref={ref}
            sx={{
              background: "green",
              minHeight: "calc(100% - 190px)",
              background: `${
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0]
              }`,
              position: "relative",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",

              "&:before": {
                content: "''",
                display: "block",
                width: "32px",
                height: "32px",
                position: "absolute",
                left: 0,
                // top:0,
                zIndex: 1,
                backgroundColor: `${
                  theme.palette.mode === "dark"
                    ? colors.grey[200]
                    : colors.grey[0]
                }`,
                top: "40px",
                height: "48px",
                width: "24px",
                borderTopLeftRadius: "24px",
                boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                transition: "250ms",
              },

              "&:after": {
                content: "''",
                display: "block",
                width: "32px",
                height: "32px",
                position: "absolute",
                top: 0,
                zIndex: 1,
                backgroundColor: `${
                  theme.palette.mode === "dark"
                    ? colors.grey[200]
                    : colors.grey[0]
                }`,
                top: "40px",
                right: 0,
                height: "48px",
                width: "24px",
                borderTopLeftRadius: "24px",
                boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                transform: "scaleX(-1)",
                transition: "250ms",
              },

              "@media screen and (max-width: 47.9375em)": {
                "&:after, &:before": {
                  top: "-0px",
                },
              },
            }}
          >
            <>
              <RelationOrders relation={relation} config={config.orders} onActiveChange={reportPanel("orders")} />
              <RelationOrderLogs relationId={relation} config={config.orderLogs} />
              <RelationInbounds relation={relation} config={config.inbounds} />
              <RelationReturns relation={relation} config={config.returns} />
              <RelationProducts relation={relation} config={config.products} />
              <RelationVirtualProducts
                relation={relation}
                config={config.virtualproducts}
              />
              <RelationInvoices relation={relation} config={config.invoices} onActiveChange={reportPanel("invoices")} />
              {/* Imported from relation sidepanel */}
              <Financial config={config.financial} relationId={relation} />
              <Saleschannels config={config.saleschannels} relationId={relation} />
              <RelationUsers config={config.users} relationId={relation} />
              <RelationRunners relation={relation} config={config.runners} />
              <RelationShelfwarmers relation={relation} config={config.shelfwarmers} />
              {/* <OutboundActionRequiredView config={config.actionRequired} />
                    <OutboundReplenishView config={config.replenish} />
                    <OutboundPostponed tableConfig={tableConfig} config={config.postponed}/>
                    <OutboundShippedView config={config.shipped}/>
                    <OutboundSnoozedView config={config.snoozed}/>
                    <OutboundBackorderView config={config.backorders}/>
                    <OutboundCancelledView config={config.cancelled}/>
                    <OutboundBolView config={config.bol}/>
                    {isFulfilment && <CustomerOrdersView tableConfig={tableConfig} config={config.customerOrders}/>} */}
            </>
          </TabView3>
          {/* </TabView> */}
          {spLoading && 
            <SpRelationDetails
                isExtended={isExtended}
                setIsExtended={setIsExtended}
                relationId={relation}
                // data={relationData}                
            /> 
        }
        </>
      ) : null}
    </Box>
  );
};

export default RelationData;
